import request from '@/utils/request'
const api_name = 'propertycomplaint'
export default{
    getAllPropertyComplaints(){
        return request({
            url:`/${api_name}/getallpropertycomplaints`,
            method:'get'
        })
    },
    getPropertyComplaintsByPropertyComplaint(pojo){
        return request({
            url:`/${api_name}/getpropertycomplaintbypropertycomplaintsubject`,
            method:'post',
            data:pojo
        })
    },
    addPropertyComplaint(pojo){
        return request({
            url:`/${api_name}/addpropertycomplaint`,
            method:'post',
            data:pojo
        })
    },
    updatePropertyComplaint(pojo){
        return request({
            url:`/${api_name}/updatepropertycomplaint`,
            method:'post',
            data:pojo
        })
    },
    deletePropertyComplaint(id){
        return request({
            url:`/${api_name}/deletepropertycomplaint?id=`+id,
            method:'post',
        })
    },
    
}







